import {combineReducers} from 'redux';
import {address} from './address';
import PersonReducer from './person';
import ContactReducer from './contact';
import RobotReducer from './robot';
import {match} from './match';
import {notification} from './notification';

const rootReducer = combineReducers({
  address,
  match,
  notification,
  person: PersonReducer,
  contact: ContactReducer,
  robot: RobotReducer,
});

export default rootReducer;
